import AddIcon from "@mui/icons-material/Add";
import SearchIcon from "@mui/icons-material/Search";
import SyncIcon from "@mui/icons-material/Sync";
import type {UseEntityData} from "crqlar-react-common/dist/components/useEntity";
import type {OhipConfig} from "crqlar-react-common/dist/models/integrations/ohip/ohip.config";
import {OhipTaskService} from "crqlar-react-common/dist/services/integrations/ohip/ohipTask.service";
import {useState} from "react";
import {useTranslation} from "react-i18next";
import SyncTasksTable from "../../common/SyncTasksTable";
import FetchEntitiesDialog from "./FetchEntitiesDialog";

interface Props {
    configData: UseEntityData<OhipConfig>
}

const OhipTasks = ({configData}: Props) => {
    const {t} = useTranslation();
    const [fetchEntitiesDialogOpen, setFetchEntitiesDialogOpen] = useState(false);
    const configId = configData.item.id;

    return (
        <SyncTasksTable
            configId={configId}
            tableId="system-ohip-sync-tasks"
            list={OhipTaskService.getAll}
            actions={[
                {
                    id: 'btn-fetch-specific-entities',
                    label: t('Fetch specific entities'),
                    startIcon: <SearchIcon/>,
                    onClick: () => setFetchEntitiesDialogOpen(true),
                    refreshAfter: false
                },
                {
                    id: 'btn-schedule-daily-sync',
                    label: t('Schedule daily sync'),
                    startIcon: <SyncIcon/>,
                    onClick: () => OhipTaskService.scheduleDailySync(configId!)
                },
                {
                    id: 'btn-schedule-full-sync',
                    label: t('Schedule full sync'),
                    startIcon: <AddIcon/>,
                    onClick: () => OhipTaskService.scheduleFullSync(configId!)
                }
            ]}
            renderDialogs={refresh => (
                <FetchEntitiesDialog
                    open={fetchEntitiesDialogOpen}
                    onClose={() => setFetchEntitiesDialogOpen(false)}
                    configId={configId!}
                    onSuccess={refresh}
                />
            )}
        />
    );
};

export default OhipTasks;
